import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';
import api from '../../utils/api';

function VendorRegister() {
  const { t } = useI18n();

  const [form, setForm] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: '',
    contact_email: '',
    contact_phone: '',
    line_id: '',
    payout_terms: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirmPassword) {
      setError(t('auth.passwordsNoMatch'));
      return;
    }

    if (form.password.length < 8) {
      setError(t('auth.passwordMinLength'));
      return;
    }

    setSubmitting(true);

    try {
      await api.post('/auth/register/vendor', {
        email: form.email,
        password: form.password,
        name: form.name,
        contact_email: form.contact_email || null,
        contact_phone: form.contact_phone || null,
        line_id: form.line_id || null,
        payout_terms: form.payout_terms || null
      });
      setSuccess(true);
    } catch (err) {
      setError(err.message || t('auth.registrationFailed'));
    } finally {
      setSubmitting(false);
    }
  }

  if (success) {
    return (
      <div style={{ minHeight: '100vh', background: 'var(--background)', display: 'flex', alignItems: 'center' }}>
        <div className="container">
          <div className="card" style={{ maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✓</div>
            <h1 style={{ fontSize: '20px', marginBottom: '8px' }}>{t('auth.registrationSubmitted')}</h1>
            <p className="text-secondary mb-4">
              {t('auth.vendorPendingApproval')}
            </p>
            <Link to="/login" className="btn btn-primary">
              {t('auth.backToLogin')}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--background)', display: 'flex', alignItems: 'center', padding: '20px 0' }}>
      <div className="container">
        <div className="card" style={{ maxWidth: '450px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '24px', marginBottom: '8px', textAlign: 'center' }}>
            {t('auth.vendorRegistration')}
          </h1>
          <p className="text-secondary text-center mb-4">
            {t('auth.vendorRegistrationSubtitle')}
          </p>

          {error && (
            <div style={{ background: '#fef2f2', color: '#dc2626', padding: '12px', borderRadius: '6px', marginBottom: '16px', fontSize: '14px' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="label">{t('auth.businessName')} *</label>
              <input
                type="text"
                className="input"
                value={form.name}
                onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))}
                required
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.loginEmail')} *</label>
              <input
                type="email"
                className="input"
                value={form.email}
                onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))}
                required
              />
            </div>

            <div className="form-group">
              <label className="label">{t('common.password')} *</label>
              <input
                type="password"
                className="input"
                value={form.password}
                onChange={(e) => setForm(f => ({ ...f, password: e.target.value }))}
                required
                minLength={8}
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.confirmPassword')} *</label>
              <input
                type="password"
                className="input"
                value={form.confirmPassword}
                onChange={(e) => setForm(f => ({ ...f, confirmPassword: e.target.value }))}
                required
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.contactEmail')}</label>
              <input
                type="email"
                className="input"
                value={form.contact_email}
                onChange={(e) => setForm(f => ({ ...f, contact_email: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.contactPhone')}</label>
              <input
                type="tel"
                className="input"
                value={form.contact_phone}
                onChange={(e) => setForm(f => ({ ...f, contact_phone: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.lineId')}</label>
              <input
                type="text"
                className="input"
                value={form.line_id}
                onChange={(e) => setForm(f => ({ ...f, line_id: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label className="label">{t('auth.payoutTerms')}</label>
              <textarea
                className="input"
                rows={2}
                value={form.payout_terms}
                onChange={(e) => setForm(f => ({ ...f, payout_terms: e.target.value }))}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={submitting}
            >
              {submitting ? t('auth.submitting') : t('auth.submitRegistration')}
            </button>
          </form>

          <p className="text-center text-secondary mt-4" style={{ fontSize: '14px' }}>
            {t('auth.haveAccount')} <Link to="/login" style={{ color: 'var(--primary)' }}>{t('auth.loginHere')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default VendorRegister;
